import { Button, Form, Input, Table, Select, Modal, Typography } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { PlusCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { formatPhoneNumber, formatMobileNumber, formatValueOnChange, formatTinNumber } from 'utils/helper';
import { getCustomerBillDetails, deleteBillDtl } from 'services/customers/customers';
import Message from 'shared_components/message';

const { Option } = Select;

const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
	const [form] = Form.useForm();
	return (
		<Form form={form} component={false}>
			<EditableContext.Provider value={form}>
				<tr {...props} />
			</EditableContext.Provider>
		</Form>
	);
};

const EditableCell = ({
	title,
	editable,
	children,
	dataIndex,
	record,
	handleSave,
	...restProps
}) => {
	const [editing, setEditing] = useState(false);
	const inputRef = useRef(null);
	const form = useContext(EditableContext);
	useEffect(() => {
		if (editing) {
			inputRef.current.focus();
			inputRef.current.select();
		}
	}, [editing]);

	const toggleEdit = () => {
		setEditing(!editing);
		form.setFieldsValue({
			[dataIndex]: record[dataIndex],
		});
	};

	const save = async () => {
		try {
			const values = await form.validateFields();
			toggleEdit();
			handleSave({ ...record, ...values }, values);
		} catch (errInfo) {
			console.log('Save failed:', errInfo);
		}
	};

	const handleInputChange = ({ e, dataIndex }) => {
		// console.log('dataIndex', dataIndex);
		// console.log('e.target.value', e.target.value);

		switch (dataIndex) {
			case 'tel_no':
				form.setFieldsValue({ [dataIndex]: formatPhoneNumber(e.target.value) });
				break;
			case 'mobile_no':
				form.setFieldsValue({ [dataIndex]: formatMobileNumber(e.target.value) });
				break;
			// case 'tax_id_no':
			// 	form.setFieldsValue({ [dataIndex]: formatTinNumber(e.target.value)});
			// 	break;
			default:
				form.setFieldsValue({ [dataIndex]: e.target.value });
		}
	};

	const handleTaxNo = e => {
		const formatedValue = formatValueOnChange(e.target.value, 'numberonly');
		form.setFieldsValue({ tax_id_no: formatedValue });
	};

	let childNode = children;

	if (editable) {
		if (dataIndex === 'billing_address') {
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					rules={[
						{
							required: true,
							message: 'Required Field',
						},
					]}
				>
					<Input ref={inputRef} onPressEnter={save} onBlur={save} maxLength={200} />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
						wordBreak: 'break-word',
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
		} 
		else if(dataIndex === 'tel_no'){
			childNode = editing ? (
				<Form.Item name={dataIndex}>
					<Input ref={inputRef} onPressEnter={save} onBlur={save} maxLength={50} />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			)
		}else if(dataIndex === 'mobile_no'){
			childNode = editing ? (
				<Form.Item name={dataIndex}>
					<Input ref={inputRef} onPressEnter={save} onBlur={save} maxLength={50} />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			)
		}
		else if (dataIndex === 'business_name') {
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					rules={[
						{
							required: true,
							message: 'Required Field',
						},
					]}
				>
					<Input ref={inputRef} onPressEnter={save} onBlur={save} maxLength={100} />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
						wordBreak: 'break-word',
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
		} else if (dataIndex === 'tax_id_no') {
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					rules={[
						{
							required: true,
							message: 'Required Field',
						},
					]}
				>
					<Input
						ref={inputRef}
						onPressEnter={save}
						onBlur={save}
						// onChange={handleTaxNo}
						onChange={e => {
							handleInputChange({ e, dataIndex });
						}}
						maxLength={20}
					/>
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
		} else if (dataIndex === 'business_style') {
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					rules={[
						{
							required: true,
							message: 'Required Field',
						},
					]}
				>
					<Input ref={inputRef} onPressEnter={save} onBlur={save} maxLength={100} />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
						wordBreak: 'break-word',
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
		} else if (dataIndex === 'contact_person') {
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					// rules={[
					// 	{
					// 		required: true,
					// 		message: 'Required Field',
					// 	},
					// ]}
				>
					<Input ref={inputRef} onPressEnter={save} onBlur={save} maxLength={100} />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
						wordBreak: 'break-word',
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
		}
		else
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					rules={[
						{
							required: true,
							// message: `${title} is required.`,
							message: 'Required Field',
						},
					]}
				>
					<Input
						ref={inputRef}
						onPressEnter={save}
						onBlur={save}
						// style={ {textTransform: "uppercase"} }
						onChange={e => {
							handleInputChange({ e, dataIndex });
						}}
					/>
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					onClick={toggleEdit}
					// style={ {textTransform: "uppercase"} }
				>
					{children}
				</div>
			);
	}

	return <td {...restProps}>{childNode}</td>;
};

function BillingAddTable(props) {
	const { data } = props;
	const [value, setValue] = useState(undefined);
	const customerBillProps = props.dataBillAdd === 'undefined' ? '' : props.dataBillAdd;
	const [dataSource, setDataSource] = useState([]);
	const [count, setCount] = useState(2);
	const [linesForDelete, setLinesForDelete] = useState([]);
	const [msgList, setMsgList] = useState([]);
	const [initData, setInitData] = useState([]);

	useEffect(() => {
		props.onSubmit(dataSource);
		// props.touchedBillAdd(true);
	}, [dataSource]);

	useEffect(() => {
		props.getInitData(initData);
		// props.touchedBillAdd(true);
	}, [initData]);

	useEffect(()=>{
		props.forDeleteBilling(linesForDelete);
	}, [linesForDelete]);

	useEffect(() => {
		function fetchData() {
			setMsgList(props.messagesList);
		}
		fetchData();
	}, [props.messagesList]);

	useEffect(() => {
		if (props.isEditting) {
			async function fetchData() {
				if (props.isEditting) {
					const getCustomer_id = {
						customer_id: customerBillProps.customer_id,
					};

					const CustomerBillDetails = await getCustomerBillDetails(getCustomer_id);
					setDataSource(CustomerBillDetails);	
					setInitData(CustomerBillDetails); //for checking of form			
				}
			}
			fetchData();
		}
	}, []);

	const handleDeleteLine = key => {
		const newData = dataSource.filter(item => item.billing_address_id !== key.billing_address_id);
		setDataSource(newData);
		setLinesForDelete(linesForDelete.concat(key.billing_address_id));
	};

	const Astrx = <span style={{color: "red", fontSize: 20, fontWeight: 'bold'}}>*</span>;

	const defaultColumns = [
		{
			title: <div>{Astrx}BUSINESS NAME</div>,
			dataIndex: 'business_name',
			key: 'business_name',
			editable: !props.disabled,
			width: '15%',
			overflow: 'auto',
		},
		{
			title: <div>{Astrx}TAX ID NO.</div>,
			dataIndex: 'tax_id_no',
			key: 'tax_id_no',
			editable: !props.disabled,
			width: '10%',
			overflow: 'auto',
		},
		{
			title: <div>{Astrx}ADDRESS</div>,
			dataIndex: 'billing_address',
			key: 'billing_address',
			editable: !props.disabled,
			width: '25%',
			overflow: 'auto',
		},
		{
			title: 'TEL. NO.',
			dataIndex: 'tel_no',
			key: 'tel_no',
			editable: !props.disabled,
			width: '13%',
			overflow: 'auto',
		},
		{
			title: 'MOBILE NO.',
			dataIndex: 'mobile_no',
			key: 'mobile_no',
			editable: !props.disabled,
			width: '13%',
			overflow: 'auto',
		},
		{
			title: <div>{Astrx}BUSINESS STYLE</div>,
			dataIndex: 'business_style',
			key: 'business_style',
			editable: !props.disabled,
			width: '15%',
			overflow: 'auto',
		},
		{
			title: 'CONTACT PERSON',
			dataIndex: 'contact_person',
			key: 'contact_person',
			editable: !props.disabled,
			width: '17%',
			overflow: 'auto',
		},
		{
			title: 'OPERATION',
			dataIndex: 'bill_operation',
			width: '5%',
			overflow: 'auto',
			render: (_, record) =>
				dataSource.length >= 1 ? (
					// eslint-disable-next-line jsx-a11y/anchor-is-valid
					<Typography.Link style={{textTransform: 'capitalize'}} onClick={() => handleDeleteLine(record)}
						disabled={props.disabled}
					>DELETE</Typography.Link>
				) : null,
		},
	];


	const handleSubmit = () =>{
		props.touchedBillAdd(true);
	  }

	const handleAdd = () => {
		const newData = {
			// key: count,
			billing_address_id: count,
			business_name: '-',
			tax_id_no: '-',
			billing_address: '-',
			tel_no: '(632)XXXX-YYYY',
			mobile_no: '(639)XX-XXX-YYYY',
			business_style: '-',
			contact_person: '-',
		};
		setDataSource([...dataSource, newData]);
		setCount(count + 1);
	};

	function sendNewData(val){
		props.sendNewBill(val);
	}

	const handleSave = (row, values) => {
		const newData = [...dataSource];
		const index = newData.findIndex(item => row.billing_address_id === item.billing_address_id);
		const item = newData[index];
		newData.splice(index, 1, { ...item, ...row });
		
		// check existing lines with the same business name of the current row
		const tblDataRet = newData.filter((items) => 
			items.billing_address === (row.billing_address === undefined ? '' : row.billing_address)
		);

		if(tblDataRet.length > 1 && row.billing_address !== '-'){
			console.log('Not allowed to Input same address')
		}else{
			setDataSource(newData);
			handleSubmit();
			sendNewData(newData);
		}

	};

	const components = {
		body: {
			row: EditableRow,
			cell: EditableCell,
		},
	};

	const columns = defaultColumns.map(col => {
		if (!col.editable) {
			return col;
		}

		return {
			...col,
			onCell: record => ({
				record,
				editable: col.editable,
				dataIndex: col.dataIndex,
				title: col.title,
				handleSave,
			}),
		};
	});

	return (
		<div>
			<Button
				onClick={handleAdd}
				style={{
					marginTop: 20,
				}}
				icon={<PlusCircleOutlined />}
				disabled={props.disabled}
			>
				BILLING ADDRESS
			</Button>
			<Table
				rowKey={record => record.billing_address_id}
				style={{ textTransform: 'uppercase' }}
				components={components}
				rowClassName={() => 'editable-row'}
				bordered
				dataSource={dataSource}
				columns={columns}
				pagination={{ defaultPageSize: 5 }}
			/>
		</div>
	);
}

export default BillingAddTable;
